import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3c7dcb71")

_pushScopeId("data-v-3c7dcb71")
const _hoisted_1 = { class: "login-form card grid" }
const _hoisted_2 = { class: "title row center" }
const _hoisted_3 = {
  key: 0,
  class: "error row"
}
const _hoisted_4 = { class: "form-group col-1" }
const _hoisted_5 = { class: "form-group col-1" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  class: "btn",
  type: "submit"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("hr", { class: "row" }, null, -1)
const _hoisted_9 = { class: "row center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h1", null, _toDisplayString(_ctx.$t("login-title")), 1)
    ]),
    (_ctx.errorText)
      ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.errorText)), 1))
      : _createCommentVNode("", true),
    _createVNode("form", {
      class: "row",
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.doLogin()), ["prevent"]))
    }, [
      _createVNode("div", _hoisted_4, [
        _withDirectives(_createVNode("input", {
          id: "email",
          required: "",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event)),
          type: "text",
          placeholder: _ctx.$t('email')
        }, null, 8, ["placeholder"]), [
          [_vModelText, _ctx.email]
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _withDirectives(_createVNode("input", {
          id: "password",
          required: "",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.password = $event)),
          type: "password",
          placeholder: _ctx.$t('password')
        }, null, 8, ["placeholder"]), [
          [_vModelText, _ctx.password]
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("button", _hoisted_7, _toDisplayString(_ctx.$t("login")), 1)
      ])
    ], 32),
    _hoisted_8,
    _createVNode("div", _hoisted_9, [
      _createVNode(_component_router_link, {
        class: "small",
        to: "/register"
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("register")), 1)
        ]),
        _: 1
      })
    ])
  ]))
})